export const QUESTIONS = {
  apply: 'apply',
  creditScore: 'creditScore',
  fee: 'fee',
  payment: 'payment',
  payoutSpeed: 'payoutSpeed',
  useOfFunds: 'useOfFunds',
  slickRequired: 'slickRequired',
  repeatOffer: 'repeatOffer',
  increaseChances: 'increaseChances',
};
